export default {
  locations: 'Locations',
  searchPlaceholder: 'Search by name',
  addLocation: 'Add location',
  city: 'City',
  region: 'Region',
  name: 'Name',
  address: 'Address',
  merchantCategoryCode: 'Merchant category code',
  geolocation: 'Geolocation',
  latitude: 'Latitude',
  longitude: 'Longitude',
  editLocation: 'Edit location',
  addCoordinates: 'Add coordinates',
  'Extra notes to address': 'Extra notes to address',
  'Add notes how to find the place': 'Add notes how to find the place',
  Icon: 'Icon',
  Upload: 'Upload',
  Photos: 'Photos',
  MCC: 'MCC',
  'Working hours': 'Working hours',
  'Add time range': 'Add time range',
  // Tooltips
  geolocationHint:
    'To change the coordinates click at the required point of the map below or enter them manually in the format 00.000000',
  'If unique icon is defined for location it will be shown instead of company’s icon.':
    'If unique icon is defined for location it will be shown instead of company’s icon.',
  'Add photos that will help your visitors to find the place. Max. {{maxCount}} photos allowed.':
    'Add photos that will help your visitors to find the place. Max. {{maxCount}} photos allowed.',
  'Select days when location works and add one or more time ranges that do not intersect.':
    'Select days when location works and add one or more time ranges that do not intersect.',
};
